import {inject, Injectable} from '@angular/core';
import {firstValueFrom} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {DatosApp, Preinscripcion} from '@kilobytelab/types';
import {API_URL_TOKEN} from '../token';

@Injectable({
  providedIn: 'root'
})
export class ApiPreinscService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL_TOKEN);

  /*** preinscripciones ***/

  getPreinscripciones(): Promise<Preinscripcion[]> {
    const url = `${this.apiUrl}preinscripciones`;
    return firstValueFrom(this.http.get<Preinscripcion[]>(url))
  }
  resendPreinscripcion(user: string): Promise<void> {
    const url = `${this.apiUrl}preinscripciones/resend/${user}`;
    return firstValueFrom(this.http.get<void>(url))
  }
  matricularPreinscripcion(user: string, id: number): Promise<void> {
    const url = `${this.apiUrl}preinscripciones/matricula/${user}/${id}`;
    return firstValueFrom(this.http.get<void>(url))
  }
  checkPreinscripcion (data: {bbdd: string, user: string, code: string, recaptchaResponse: string}): Promise<DatosApp[]> {
    const url = `${this.apiUrl}preinscripciones/check`;
    return firstValueFrom(this.http.post<DatosApp[]>(url, data))
  }
  savePreincripcion (data: {bbdd: string, user: string, code: string, data: string, recaptchaResponse: string}): Promise<void> {
    const url = `${this.apiUrl}preinscripciones/update`;
    return firstValueFrom(this.http.post<void>(url, data))
  }
  savePreinscripcion(datos: Preinscripcion): Promise<void> {
    const url = `${this.apiUrl}preinscripciones`;
    return firstValueFrom(this.http.put<void>(url, datos))
  }
  deletePreinscripcion(user: string): Promise<any> {
    const url = `${this.apiUrl}preinscripciones/${user}`;
    return firstValueFrom(this.http.delete<any>(url))
  }

}
